import React from "react";
import "./FormError.scss";
/**
 * Displays info text for the form element. Typically not used directly, but by the other form controls.
 */
function FormInfo({ info, langKey, t }) {
    return info === true ? (React.createElement("p", { className: "info", dangerouslySetInnerHTML: { __html: t(langKey + "Info") } })) : info ? (React.createElement("p", { className: "info" }, info)) : null;
}
export default FormInfo;
